import React from "react";
import { Select, Button, Icon, Popover, Tooltip } from "antd";
import classNames from "classnames";
import WeaTools from "../../wea-tools";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";
import trim from "lodash/trim";
import isString from "lodash/isString";
import random from "lodash/random";
import OGroup from "./OGroup";
import uniq from "lodash/uniq";
import WeaHrmlist from "../../wea-hrmlist";
import WeaHelpfulTip from "../../wea-helpful-tip";
import WeaLocaleProvider from "../../wea-locale-provider";
import WindowFunc from "../../wea-tools/window";

const Option = Select.Option;
const { getLabel, formatMultiLang } = WeaLocaleProvider;

class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      value: [],
      loading: false,
      focus: false,
      dropdownWidth: 200,
      hrmlist: [],
      hrmlistVisible: false
    };
    this.selectedData = {};
  }
  componentWillReceiveProps(nextProps, nextState) {
    this.props.isClearData !== nextProps.isClearData && this.clear();
    if (
      this.props.defaultFocus !== nextProps.defaultFocus &&
      nextProps.defaultFocus
    ) {
      this.setState({ focus: true });
    }
  }

  // shouldComponentUpdate(nextProps,nextState) {
  //   return !isEqual(this.props.datas, nextProps.datas)
  //     || !isEqual(this.props.selectedValues, nextProps.selectedValues)
  //     || this.props.type !== nextProps.type
  //     || this.props.style !== nextProps.style
  //     || this.props.inputName !== nextProps.inputName
  //     || this.props.inputId !== nextProps.inputId
  //     || this.props.viewAttr !== nextProps.viewAttr
  //     || this.props.defaultFocus !== nextProps.defaultFocus
  //     || this.state.value !== nextState.value
  //     || !isEqual(this.state.data, nextState.data)
  //     || this.state.loading !== nextState.loading;
  // }
  componentDidUpdate() {
    const dom = this.refs.searchWrapperMui;
    if (this.state.focus) {
      $(dom)
        .find(".ant-select-search--inline")
        .css("minWidth", "10px");
      $(dom)
        .find("input")
        .focus();
    } else {
      $(dom)
        .find(".ant-select-search--inline")
        .css("minWidth", "0px");
    }
  }
  componentDidMount() {
    const { dropdownWidth } = this.state;
    const w = $(this.refs.searchWrapperMui).outerWidth();
    if (dropdownWidth < w) {
      this.setState({ dropdownWidth: w });
    }
  }
  focus() {
    this.refs.select.refs.rcSelect.onPlaceholderClick &&
      this.refs.select.refs.rcSelect.onPlaceholderClick();
  }
  clear() {
    this.setState({ data: [] });
    this.selectedData = {};
  }
  isCrm() {
    const type = this.props.type || 1;
    return type === 1 || type === 17 || type === "1" || type === "17";
  }
  getData(name = "") {
    let { type, oldUrl, completeURL } = this.props;
    let url = completeURL || `/api/public/browser/complete/${type}?`;
    let method = "GET";
    type = type || 1;
    if (type == "17") {
      method = "POST";
    }
    if (oldUrl) {
      url = `/api/ec/api/data/search?type=${type}&`;
    }
    if (trim(name)) {
      WeaTools.callApi(
        `${url}q=${encodeURIComponent(trim(name))}`,
        method
      ).then(res => {
        let resD =
          isString(res.datas) && res.datas.length > 0
            ? JSON.parse(res.datas)
            : res.datas;
        if (oldUrl) resD = res;
        resD = resD || [];
        if (this.isCrm()) {
          // 需要过滤已选中数据（部门，分组）
          let filterDatas = [];
          let selectIds = [];
          const { datas, selectedValues } = this.props;
          selectedValues &&
            selectedValues.forEach(k => {
              let target = datas[k];
              if (target.type === "resource") {
                selectIds.push(target.id);
              } else {
                selectIds = selectIds.concat(k.split(","));
              }
            });
          resD.forEach(item => {
            item.type = "resource";
            item.nodeid = `resource_${item.id}x`;
            item.lastname = item.name;
            if (selectIds.indexOf(item.id) === -1) {
              filterDatas.push(item);
            }
          });
          resD = filterDatas;
        }
        this.setState({
          data: resD,
          loading: false,
          activeKey: this.getActiveKey(resD)
        });
      });
    } else {
      this.setState({ data: [], loading: false, activeKey: "" });
    }
  }
  getActiveKey(data) {
    const { selectedValues = [] } = this.props;
    let v = "";
    if (data && data.length > 0) {
      let target = data.filter(d => selectedValues.indexOf(d.id) == -1);
      if (!isEmpty(target)) v = target[0].id;
    }
    return v;
  }
  getItemById(id) {
    const { data } = this.state;
    const { datas } = this.props;
    if (datas[id]) return datas[id];
    if (!isEmpty(data)) {
      for (let i = 0; i < data.length; i++) {
        if (id === data[i].id) return data[i];
      }
    }
  }
  handleChange(values) {
    this.selectedData = {};
    values.forEach(v => {
      let item = this.getItemById(v);
      if (item) this.selectedData[v] = item;
    });
    this.props.onChange && this.props.onChange(values, this.selectedData);
    if (this.hasAll() && values.length === 0) {
      this.props.dropAllUserGroup && this.props.dropAllUserGroup();
    }
    this.setState({ activeKey: "" });
  }
  handleBlur() {
    this.setState({ activeKey: "" });
    this.setState({ data: [] });
    this.props.onBlur && this.props.onBlur();
  }
  handleFocus() {
    this.setState({ focus: true });
    this.props.onFocus && this.props.onFocus();
  }
  handleSearch(value) {
    const { type } = this.props;
    if (this.hasAll() || type === "141") {
      return;
    }
    this.setState({ loading: true });
    this.getData(value);
    this.props.onSearch && this.props.onSearch(value);
  }
  handleClick(e) {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.handleClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.handleClickInner(e);
    }
  }
  handleClickInner(e) {
    const { datas, selectedValues } = this.props;
    if (this.props.clickCallback) {
      if (this.hasAll()) {
        return;
      }
      this.props.clickCallback(selectedValues, datas);
    }
  }
  getName(item) {
    const { inputName, hideNum } = this.props;
    let name;
    if (item) {
      if (this.isCrm()) {
        if (item.type === "all") {
          if (hideNum) {
            return `${item.lastname || item.name}`;
          }
          return `${item.lastname || item.name}(${item.count})`;
        }
        if (item.type !== "resource") {
          if (hideNum) {
            return `${item.lastname || item.name}`;
          }
          return `${item.lastname || item.name}(${(item.users || []).length})`;
        }
        name = item.lastname || item.name;
      } else {
        if (inputName) {
          name = item[inputName + "span"] || item[inputName];
        }
        name = name || item.name;
      }
    }
    return name;
  }
  selectedClickHandler(e, data) {
    let item;
    if (this.isReadOnly()) {
      item = data;
    } else {
      item = this.props.datas[data.key];
    }
    if (this.isCrm()) {
      if (item.type === "resource") {
        window.openhrm(item.id);
        window.pointerXY(e.nativeEvent);
        return;
      }
      if (item.type !== "resource" && item.type !== "all") {
        let target = jQuery(e.nativeEvent.target);
        let parent = jQuery(this.refs.searchWrapperMui);
        let y = target.offset().top;
        let x = target.offset().left;
        let py = parent.offset().top;
        let px = parent.offset().left;
        let style = {
          top: y - py + 25,
          left: x - px
        };
        if (!isEmpty(item.users)) {
          this.setState({
            hrmlist: item.users,
            hrmlistVisible: true,
            hrmlistStyle: style
          });
        }
        e.stopPropagation && e.stopPropagation();
        e.preventDefault && e.preventDefault();
        e.nativeEvent && e.nativeEvent.preventDefault();
      }
    } else {
      const { linkUrl, inputId } = this.props;
      if (linkUrl) {
        let url = `${linkUrl}${item[inputId] || item.id}`;
        window.open(url);
      }
    }
  }
  //只读
  isReadOnly() {
    const { viewAttr } = this.props;
    return viewAttr === 1 || viewAttr === "1";
  }
  // 处理所有人
  hasAll() {
    const { datas } = this.props;
    let tag = false;
    forEach(datas, (value, key) => {
      if (value.type === "all") {
        tag = true;
      }
    });
    return tag;
  }
  addOnClick() {
    this.props.addOnClick && this.props.addOnClick();
  }
  countCrm() {
    const {
      datas,
      selectedValues,
      selectTypes = [],
      allDatas = []
    } = this.props;
    let count = 0;
    let ids = [];
    selectedValues &&
      selectedValues.forEach((v, index) => {
        let dataV = datas[v];
        const type = selectTypes[index];
        if (type) {
          const tempDataV = allDatas.find(k => k.id === v && k.type === type);
          if (tempDataV) dataV = tempDataV;
        }
        const item = dataV;
        if (item.type === "all") {
          count += item.count;
        } else if (item.type !== "resource") {
          item.users && item.users.forEach(u => ids.push(u.id));
        } else {
          ids.push(item.id);
        }
      });
    count += uniq(ids).length;
    return count;
  }
  showCount() {
    let bool = false;
    const {
      datas,
      selectedValues,
      selectTypes = [],
      allDatas = []
    } = this.props;
    let resources = [];
    let groups = [];
    selectedValues &&
      selectedValues.forEach((v, index) => {
        let dataV = datas[v];
        const type = selectTypes[index];
        if (type) {
          const tempDataV = allDatas.find(k => k.id === v && k.type === type);
          if (tempDataV) dataV = tempDataV;
        }
        const item = dataV;
        if (item.type === "all") {
        } else if (item.type !== "resource") {
          groups.push(item);
        } else {
          resources.push(item);
        }
      });
    if (groups.length > 1) bool = true;
    if (groups.length == 1 && resources.length > 0) bool = true;
    return bool;
  }
  render() {
    const {
      whiteBackground,
      hasScroll = true,
      mr0,
      customIconTip,
      customIcon,
      showTitle,
      underline,
      fieldName,
      hasBorder,
      layout,
      style = {},
      datas,
      viewAttr,
      maxBrowerHeight,
      resize,
      linkUrl,
      isDetail,
      hasAddBtn,
      hasAddGroup = false,
      hideOps,
      hideSelect,
      helpfulTip,
      helpfulTipProps,
      valueWarp,
      hideNum,
      className,
      noTooltip = false
    } = this.props;
    const { hrmVisible, dropdownWidth, activeKey } = this.state;
    const { props } = this;
    let { selectedValues, allDatas = [], selectTypes = [] } = this.props;
    const clsname = classNames({
      required: (viewAttr === 3 || viewAttr === "3") && isEmpty(selectedValues),
      mr15:
        /^field/.test(fieldName) ||
        (viewAttr == "3" && isEmpty(selectedValues)),
      mr0: mr0,
      resize: resize,
      "wea-associative-click":
        this.isCrm() || !isEmpty(linkUrl) || props.linked,
      custom: hasAddBtn || customIcon,
      "ext-btn": hasAddBtn || customIcon || (!this.isReadOnly() && hasAddGroup),
      border: hasBorder,
      white: whiteBackground,
      underline: underline,
      hideops: hideOps,
      "value-warp": valueWarp,
      [`${className}`]: className
    });
    const cStyle = { ...style };
    cStyle.textDecoration = "none";
    const HrmListContent = (
      <WeaHrmlist
        list={this.state.hrmlist}
        onVisibleChange={v => this.setState({ hrmlistVisible: v })}
        style={this.state.hrmlistStyle}
        visible={this.state.hrmlistVisible}
        ref="weaHrmlist"
      />
    );

    if (this.isReadOnly()) {
      let arr = [];
      selectedValues &&
        selectedValues.map((v, index) => {
          let dataV = datas[v];
          const type = selectTypes[index];
          if (type) {
            const tempDataV = allDatas.find(k => k.id === v && k.type === type);
            if (tempDataV) dataV = tempDataV;
          }
          let item = this.getName(dataV);
          if (!isString(item)) {
            arr.push(
              <a
                className="child-item wdb"
                onClick={e => this.selectedClickHandler(e, dataV)}
              >
                {item}
              </a>
            );
          } else {
            arr.push(
              <a
                className="child-item wdb"
                onClick={e => this.selectedClickHandler(e, dataV)}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            );
          }
        });
      return (
        <span
          id={`${this.props.fieldName}span`}
          className={`wea-associative-search wea-field-readonly ${clsname} ${this
            .props.cls || ""}`}
          style={style}
          ref="searchWrapperMui"
        >
          {arr}
          {!hideNum && this.isCrm() && this.showCount() && (
            <span style={{ color: "#bfbfc0" }}>
              ({getLabel(385618, "共$s人").replace(/\$s/, this.countCrm())})
            </span>
          )}
          {hasAddBtn && (
            <div className="ant-input-group-wrap extbtn">
              <Icon
                className="add-icon"
                type="plus"
                onClick={this.addOnClick.bind(this)}
              />
            </div>
          )}
          {customIcon && (
            <div className="ant-input-group-wrap extbtn custom">
              {customIconTip ? (
                <Tooltip placement="bottom" title={customIconTip}>
                  <i
                    className={`${customIcon} add-icon`}
                    onClick={this.addOnClick.bind(this)}
                  />
                </Tooltip>
              ) : (
                <i
                  className={`${customIcon} add-icon`}
                  onClick={this.addOnClick.bind(this)}
                />
              )}
            </div>
          )}
          {helpfulTip && (
            <WeaHelpfulTip
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
          <Popover
            placement="bottomLeft"
            title=""
            trigger="click"
            content={HrmListContent}
            visible={this.state.hrmlistVisible}
            onVisibleChange={v => this.setState({ hrmlistVisible: v })}
            getTooltipContainer={() => this.refs.searchWrapperMui}
            overlayClassName="hrmlist-wrapper"
          >
            <div className="hrmlistDom">&nbsp;</div>
          </Popover>
        </span>
      );
    }
    const _data = this.state.data;
    let optionsError = false;
    let options = _data
      .map(d => ({
        ...d,
        ...("showname" in d ? { showname: formatMultiLang(d.showname) } : {}),
        ...("name" in d ? { name: formatMultiLang(d.name) } : {})
      }))
      .map(d => {
        if (!d.id) {
          console && console.error(`浏览按钮脏数据 ${d}`);
          optionsError = true;
        }
        const tooltip = noTooltip ? "" : d.title || this.getName(d);
        return (
          <Option value={d.id} key={random(1000000000)} tooltip={tooltip}>
            {this.getName(d)}
          </Option>
        );
      });
    optionsError && (options = []);
    let selectedError = false;
    selectedValues &&
      selectedValues.map(v => {
        if (!v) {
          console && console.error(`浏览按钮脏数据 ${selectedValues}`);
          selectedError = true;
        }
        return options.unshift(
          <Option
            value={v}
            key={random(1000000000)}
            tooltip={this.getName(datas[v])}
          >
            {this.getName(datas[v])}
          </Option>
        );
      });
    selectedError && (selectedValues = []);
    let select = (
      <Select
        selectedClickCB={this.selectedClickHandler.bind(this)}
        {...this.props}
        ref="select"
        hasScroll={hasScroll}
        onInputBlur={() => {
          this.setState({ focus: false });
        }}
        className={valueWarp ? "value-warp" : ""}
        maxHeight={maxBrowerHeight}
        hideSelected={true}
        transitionName=""
        animation=""
        defaultValue={selectedValues}
        value={selectedValues}
        multiple={true}
        placeholder={this.props.placeholder}
        notFoundContent=""
        activeKey={activeKey}
        defaultActiveFirstOption={true}
        showArrow={false}
        filterOption={false}
        onFocus={this.handleFocus.bind(this)}
        onChange={this.handleChange.bind(this)}
        onSearch={!hideSelect && debounce(this.handleSearch, 400).bind(this)}
        onBlur={this.handleBlur.bind(this)}
        dropdownStyle={{ minWidth: dropdownWidth }}
        dropdownMenuStyle={{ maxHeight: 160 }}
        getPopupContainer={() =>
          (this.props.getPopupContainer && this.props.getPopupContainer()) ||
          layout ||
          WindowFunc.getTop().document.body
        }
      >
        {options.filter(v => !!v)}
      </Select>
    );

    // if (hideSelect) {
    //   select = null;
    // }
    let singleTitle = "";
    if (showTitle && !isEmpty(selectedValues) && !isEmpty(datas)) {
      function escape2Html(str) {
        var arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
          return arrEntities[t];
        });
      }
      let temp = [];
      selectedValues.forEach(v => {
        temp.push(this.getName(datas[v]));
      });
      singleTitle = escape2Html(temp.join(","));
    }

    const disabled = this.hasAll();

    const content = (
      <OGroup
        isshowoperategroup={hrmVisible}
        handleVisibleChange={this.handleVisibleChange.bind(this)}
        setOperatorIds={this.crmAddcb.bind(this)}
      />
    );

    return (
      <div
        title={singleTitle}
        className={`wea-associative-search wea-associative-search-mult ${clsname}`}
        style={cStyle}
        ref="searchWrapperMui"
      >
        {select}
        <Icon
          type="loading"
          style={{ display: this.state.loading ? "block" : "none" }}
        />
        {!hideOps && (
          <div className="ant-input-group-wrap">
            {disabled ? (
              <Button type="ghost" icon="search" disabled />
            ) : (
              <Button
                type="ghost"
                icon="search"
                onClick={this.handleClick.bind(this)}
              />
            )}
          </div>
        )}
        {hasAddBtn && (
          <div className="ant-input-group-wrap extbtn custom">
            <Icon
              className="add-icon"
              type="plus"
              onClick={this.addOnClick.bind(this)}
            />
          </div>
        )}
        {customIcon && (
          <div className="ant-input-group-wrap extbtn custom">
            {customIconTip ? (
              <Tooltip placement="bottom" title={customIconTip}>
                <i
                  className={`${customIcon} add-icon`}
                  onClick={this.addOnClick.bind(this)}
                />
              </Tooltip>
            ) : (
              <i
                className={`${customIcon} add-icon`}
                onClick={this.addOnClick.bind(this)}
              />
            )}
          </div>
        )}
        {this.isCrm() && hasAddGroup && (
          <div className="ant-input-group-wrap extbtn hasAddGroup">
            <Popover
              placement="bottomLeft"
              title=""
              overlayClassName="wea-hrm-group-popover"
              content={content}
              trigger="click"
              visible={hrmVisible}
              onVisibleChange={this.handleVisibleChange.bind(this)}
              getTooltipContainer={() => this.refs.searchWrapperMui}
            >
              {disabled ? (
                <Button
                  type="primary"
                  title={getLabel(84511, "快捷选择人员")}
                  size="small"
                  disabled
                >
                  <i className="icon-coms-HumanResources" />
                </Button>
              ) : (
                <Button
                  type="primary"
                  title={getLabel(84511, "快捷选择人员")}
                  size="small"
                  onClick={this.hrmOnClick.bind(this)}
                >
                  <i className="icon-coms-HumanResources" />
                </Button>
              )}
            </Popover>
          </div>
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            style={{ position: "absolute", right: -31, top: 4 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
        <Popover
          placement="bottomLeft"
          title=""
          trigger="click"
          content={HrmListContent}
          visible={this.state.hrmlistVisible}
          onVisibleChange={v => this.setState({ hrmlistVisible: v })}
          getTooltipContainer={() => this.refs.searchWrapperMui}
          overlayClassName="hrmlist-wrapper"
        >
          <div className="hrmlistDom">&nbsp;</div>
        </Popover>
      </div>
    );
  }
  handleVisibleChange(visible) {
    this.setState({ hrmVisible: visible });
  }
  hrmOnClick() {
    this.setState({ hrmVisible: true });
  }
  crmAddcb(data) {
    let datas = [];
    if (data.isAllUser) {
      datas.push({
        type: "all",
        count: data.count,
        ids: data.ids,
        lastname: getLabel(1340, "所有人")
      });
    } else {
      datas = data.datas;
    }
    this.props.appendSearchValues && this.props.appendSearchValues(datas, true);
  }
}
export default main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-associative-search-mult/index.js